/* eslint-disable internal-rules/no-invalid-shared-folder-exports */
export * from './aspectRatio';
export * from './getDeviceAdjustedImageSize';

export type MediaProvider = 'youtube' | 'other';

// see: https://gist.github.com/rodrigoborgesdeoliveira/987683cfbfcc8d800192da1e73adc486
export const YOUTUBE_REGEX =
	/((?:http:|https:)*?\/\/(?:www\.|))(youtube\.com|m\.youtube\.com|youtu\.|youtube-nocookie\.com)(.*(?:v=|v%3D|v\/|(?:a|p)\/(?:a|u)\/\d.*\/|watch\?|vi(?:=|\/)|\/embed\/|oembed\?|be\/|e\/)(?:[^&?%#/\n]*))/;

export function getMediaProvider(url: string): MediaProvider {
	if (YOUTUBE_REGEX.test(url)) {
		return 'youtube';
	}
	// TODO others (tiktok, ...)
	return 'other';
}

/**
 * Make sure to use the youtube-nocookie domain.
 */
export function processYoutubeDomain(url: string): string {
	// replace any youtube domain with the youtube-nocookie domain
	return url.replace(YOUTUBE_REGEX, (_m, g1, _g2, g3) => `${g1}youtube-nocookie.com${g3}`);
}
